// @flow
import * as React from 'react'
import styled from 'styled-components'
import { Tween, ScrollTrigger } from 'react-gsap'
import { FadeInImage } from '@components/shared/FadeInImage'
import { colors } from '@components/shared'

export default function SectionBackgroundImageParallax (props: {
  uniqueId: string,
  backgroundColor: string,
  imageUrl: string,
  height: number,
  width: number
}): React.Node {
  const { backgroundColor, imageUrl, height, width, uniqueId } = props

  if (!imageUrl || !height || !width) {
    return null
  }

  return (
    <ScrollTrigger
      id={`marketing-section-background-${uniqueId}`}
      start="30% start"
      end="90% 20%"
      scrub={true}
    >
      <Tween
        position='0'
        from={{
          yPercent: 0
        }}
        to={{
          yPercent: 50
        }}
      >
        <BackgroundImageContainer backgroundColor={backgroundColor}>
          <FadeInImage
            src={imageUrl}
            height={height}
            width={width}
            ariaHidden={true}
          />
        </BackgroundImageContainer>
      </Tween>
    </ScrollTrigger>
  )
}

const BackgroundImageContainer = styled.div`
  left: 0;
  position: absolute;
  top: -50%;
  z-index: -1;
  height: 150%;
  right: 0;
  backgroundcolor: ${(props: { backgroundColor: string }): string =>
    props.backgroundColor || colors.midnightBlue};
`
